// @flow

export function translateErrorMessagePT(errorCode: string): ?string {
  switch (errorCode) {
    case 'CI-000':
    case 'BP-DR-112':
      return 'Por favor, utilize outro cartão, ou escolha outro método de pagamento.';
    case 'IT-500':
      return 'Sua conexão está precisando de algumas vitaminas, assim que ela estiver forte novamente tente completar a ação.';
    case 'PR-001':
      return 'Seu pagamento não foi aprovado. Revise seus dados ou escolha outro método de pagamento.';
    case 'BP-R-32':
      return 'Ops, essa compra é maior que limite permitido para compras feitas no EBANX. Por favor, tente um valor menor ou dê um alô para nosso suporte acessando nossa <support>central de ajuda</support>, selecione a ajuda personalizada e fale com um de nossos agentes que podemos te explicar melhor.';
    case 'BP-DR-6':
      return 'Este método de pagamento não esta disponível para o valor da sua compra. Selecione outro método de pagamento.';
    case 'BP-DR-7':
      return 'Este método de pagamento não esta disponível para o valor da sua compra. Selecione outro método de pagamento.';
    case 'BP-DR-13':
      return 'Nome é requerido.';
    case 'BP-DR-15':
      return 'E-mail é requerido.';
    case 'BP-DR-17':
      return 'O email que você inseriu não é válido.';
    case 'BP-DR-18':
      return 'Encontramos um problema com o seu cadastro, dê um alô para nosso suporte acessando nossa <support>central de ajuda</support>, selecione a ajuda personalizada e fale com um de nossos agentes, que eles irão te ajudar a completar a transação';
    case 'BP-DR-21':
      return 'Para concluir esta compra, é preciso que você tenha no mínimo 16 anos. Peça para alguém maior do que 16 te ajude a completar o pagamento :)';
    case 'BP-DR-22':
      return 'CPF/CNPJ é requerido.';
    case 'BP-DR-23':
      return 'CPF/CNPJ inválido.';
    case 'BP-DR-24':
      return 'O CEP é requerido.';
    case 'BP-DR-25':
      return 'O endereço é requerido.';
    case 'BP-DR-26':
      return 'O número do endereço é requerido';
    case 'BP-DR-27':
      return 'A cidade do endereço é requerido.';
    case 'BP-DR-28':
      return 'O estado do endereço é requerido.';
    case 'BP-DR-29':
      return 'o estado do endereço é inválido.';
    case 'BP-DR-31':
      return 'O telefone é requerido.';
    case 'BP-DR-32':
      return 'O telefone é inválido.';
    case 'BP-DR-35':
      return 'Ops, houve um erro com o seu pagamento :( Tente novamente ou conclua o pagamento utilizando outro método.';
    case 'BP-DR-38':
      return 'Houve um problema com seu pagamento. Por favor, escolha outro método.';
    case 'BP-DR-39':
      return 'Ops! Identificamos um problema com seu CPF/CNPJ, tente com outro ou entre em contato conosco.';
    case 'BP-DR-40':
      return 'Ops, você atingiu o limite permitido para esse CPF para compras feitas com o EBANX. Dúvidas? dê um alô para nosso suporte acessando nossa <support>central de ajuda</support>, selecione a ajuda personalizada e fale com um de nossos agentesque podemos te explica melhor.';
    case 'BP-DR-51':
      return 'Ei, você esqueceu de preencher o número do seu cartão.';
    case 'BP-DR-55':
      return 'O Código de segurança é inválido.';
    case 'BP-DR-59':
      return 'Ops, este método de pagamento não está disponível. Mas não se preocupe, você ainda pode completar o seu pagamento com outro método.';
    case 'BP-DR-67':
      return 'A validade do cartão é inválida.';
    case 'BP-DR-75':
      return 'O número do cartão é inválido.';
    case 'BP-DR-79':
      return 'O número de parcelas é maior que o permitido';
    case 'BP-DR-83':
      return 'Seu cartão de crédito estrangeiro não pode ser processado';
    case 'BP-DR-84':
      return 'Ops, acho que você já abriu ou efetuou este pagamento. Se tiver alguma dúvida você pode falar com um dos nossos agentes, acessando nossa <support>central de ajuda</support>, em ajuda personalizada :)';
    case 'BP-DR-90':
      return 'Encontramos um problema com o seu cadastro, dê um alô para nosso suporte acessando nossa <support>central de ajuda</support>, selecione a ajuda personalizada e fale com um de nossos agentes. Eles irão te ajudar a completar a transação.';
    case 'BP-DR-91':
      return 'Ops, houve um erro com o seu pagamento :( Tente novamente ou conclua o pagamento utilizando outro método.';
    case 'BP-DR-95':
      return 'Ops, confira se você preencheu mesmo com o seu nome e não com o número do cartão.';
    case 'BP-DR-97':
      return 'Seu cartão não aceita parcelamento.';
    case 'BP-DR-98':
      return 'Email associado a um pagamento em outro país';
    case 'BP-DR-100':
      return 'Seu cartão não aceita parcelamento.';
    case 'BP-DR-101':
      return 'Seu cartão não é aceito para compras online.';
    case 'BP-DR-102':
      return 'Houve um problema com seu pagamento. Por favor, tente novamente.';
    case 'BP-DR-103':
      return 'Ops! Não foi possível completar a sua transação. Para entender o que aconteceu, entre em contato com o suporte do EBANX através da nossa <support>central de ajuda</support>, em ajuda personalizada';
    case 'BP-DR-111':
      return 'Não conseguimos validar seu documento, tente novamente mais tarde.';
    case 'AR-DB-044':
    case 'AR-DB-075':
      return 'O CUIT está incorreto. Você deve inserir o CUIT do titular da conta.';
    case 'BP-DOC-04':
      return 'Identificamos que seu registro está relatado no Banco de Dados de Contribuintes Não Confiáveis ​​da Agência de Arrecadação e Controle Aduaneiro (ARCA).\
 Devido a essa inclusão, atualmente não podemos oferecer nossos serviços de aceitação de pagamentos com transferências ou cartões (débito, crédito, compra ou pré-pago).\
 Recomendamos que você entre em contato com a ARCA para regularizar ou esclarecer sua situação. Assim que sua regularização for confirmada e o status for atualizado no banco de dados da ARCA,\
 poderemos reativar os serviços.';
    default:
      return undefined;
  }
}
